module.exports = __webpack_public_path__ + "media/src/public/img/icons/sprite-89a2b2c98cff6ad341ef04d83dbf143a.svg";